import Constant from "utils/isomorphismConstant";
import { TBannerItem, TTextModule } from "services/page/admin";
import { LITBLANGS } from "utils/lan";
enum ImgKeyType {
	Img = "img",
	ImgTwo = "imgTwo",
}

/**
 * 多语言文字适配
 * @param text: TTextModule | TProductModule
 */
export const multilingualTextDisplay = (text: TTextModule, lan: string) => {
	if (text.ig?.igroup?.[lan]) {
		return text.ig.igroup[lan].text || text.ig.igroup.en.text;
	}
	return text.content;
};

/**
 * 多语言图片适配 (单张图片使用)
 *
 * 判断不分货币？
 *
 * @param img: TBannerItem
 * @param isAtSecond boolean 是否取第二顺位图片（imgtwo）
 */
export const multilingualImgDisplay = (img: TBannerItem = {}, isAtSecond?: boolean) => {
	const imgSrcKey = isAtSecond ? ImgKeyType.ImgTwo : ImgKeyType.Img;
	return (
		img.ig.igroup?.[Constant.multiLanImgKey]?.[imgSrcKey] ||
		img.ig.igroup?.[Constant.language]?.[imgSrcKey] ||
		img.ig.igroup?.[LITBLANGS.EN]?.[imgSrcKey] ||
		img[imgSrcKey] ||
		""
	);
};

/**
 * 多语言链接适配
 * @param text: TBannerItem
 * @returns string
 */
export const multilingualLinkDisplay = (link: TBannerItem) => {
	return (
		link.ig.igroup?.[Constant.multiLanImgKey]?.link ||
		link.ig.igroup?.[Constant.language]?.link ||
		link?.link ||
		""
	);
};
